module.exports = __webpack_public_path__ + "img/a0309_4.927123aa.png";